import type { BackBehaviorOverrideContextValue } from './BackBehaviorOverrideContextValue';

export const backBehaviorOverrideDefaultValue: BackBehaviorOverrideContextValue = {
	override: null,
	setOverride: () => {},
};
